<button
  type="button"
  class="swatch"
  cdkOverlayOrigin
  #origin="cdkOverlayOrigin"
  [class.compact]="compact"
  [class.is-open]="isOpen"
  [style.background-color]="value"
  [disabled]="disabled"
  [matTooltip]="tooltip"
  [matTooltipDisabled]="!tooltip || isOpen"
  (click)="toggle($event)"
></button>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="origin"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayPositions]="positions"
  (overlayOutsideClick)="onOutsideClick($event)"
  (overlayKeydown)="onOverlayKeydown($event)"
  (detach)="close()"
>
  <div
    class="color-select-panel"
    role="dialog"
    [attr.aria-label]="label"
    (click)="$event.stopPropagation()"
  >
    @if (showPalette) {
    <div class="palette">
      @for (color of palette; track color) {
      <button
        type="button"
        class="palette-color"
        [class.is-selected]="isSelected(color)"
        [style.background-color]="color"
        [attr.aria-label]="color"
        (click)="select(color)"
      ></button>
      }
    </div>
    }

    <div
      class="sv-area"
      [style.background-color]="hueColor"
      (pointerdown)="onAreaPointerDown($event)"
      (pointermove)="onAreaPointerMove($event)"
      (pointerup)="onAreaPointerUp()"
      (pointercancel)="onAreaPointerUp()"
    >
      <span
        class="sv-handle"
        [style.left.%]="hsv.s * 100"
        [style.top.%]="(1 - hsv.v) * 100"
        [style.background-color]="currentColor"
      ></span>
    </div>

    <div class="controls-row">
      @if (canPickFromScreen) {
      <button
        type="button"
        class="eyedropper"
        [attr.aria-label]="eyedropperLabel"
        [matTooltip]="eyedropperLabel"
        (click)="pickFromScreen()"
      >
        <firebird-web-icon
          name="eyedropper"
          width="14px"
          height="14px"
        ></firebird-web-icon>
      </button>
      }
      <span class="preview" [style.background-color]="currentColor"></span>
      <input
        type="range"
        class="hue-slider"
        [style.background]="hueTrack"
        min="0"
        step="1"
        [max]="hueMax"
        [value]="hsv.h"
        (input)="onHueInput($event)"
        (change)="onHueChange()"
      />
    </div>

    <div class="values-row">
      @if (valueFormat === 'rgb') { @for (label of rgbLabels; track label; let i
      = $index) {
      <label class="value-field">
        <input
          type="number"
          min="0"
          step="1"
          [max]="channelMax"
          [value]="rgb[i]"
          (change)="onRgbChange(i, $event)"
        />
        <span>{{ label }}</span>
      </label>
      } } @else {
      <label class="value-field value-field--hex">
        <input
          type="text"
          maxlength="7"
          spellcheck="false"
          [attr.aria-label]="hexLabel"
          [value]="hexText"
          (change)="onHexChange($event)"
          (keydown.enter)="onHexEnter($event)"
        />
        <span>{{ hexFieldLabel }}</span>
      </label>
      }
      <button
        type="button"
        class="format-toggle"
        [attr.aria-label]="formatToggleLabel"
        [matTooltip]="formatToggleLabel"
        (click)="toggleFormat()"
      >
        <firebird-web-icon
          name="chevron-up-down"
          width="8px"
          height="12px"
        ></firebird-web-icon>
      </button>
    </div>

    <button
      type="button"
      class="reset"
      [disabled]="!isCustom"
      [matTooltip]="resetTooltip"
      (click)="reset($event)"
    >
      {{ resetLabel }}
    </button>
  </div>
</ng-template>
